import { createFileRoute } from "@tanstack/react-router";

import OverlaysPage from "@/app/admin/overlays/OverlaysPage";

export const Route = createFileRoute("/admin/overlays")({
  component: OverlaysPage,
});
